export default "/assets/images/mila-air-specs.png?a97569ce055a43d43ed8d634dbcc5b5d";